



















































































import {
  defineComponent, ref, useFetch,
} from '@nuxtjs/composition-api';
import PtCopyright from '~/components/Pointeger/molecules/PtCopyright.vue';
import PtSocial from '~/components/Pointeger/molecules/PtSocial.vue';
import PtNewsLetterDesc from '~/components/Pointeger/atoms/PtNewsLetterDesc.vue';
import SfIcon from '~/node_modules/@storefront-ui/vue/src/components/atoms/SfIcon/SfIcon.vue';
import SfButton from '~/node_modules/@storefront-ui/vue/src/components/atoms/SfButton/SfButton.vue';
import PtInput from '~/components/Pointeger/atoms/PtInput.vue';
import PtFooter1 from '~/components/Pointeger/atoms/PtFooter1.vue';
import PtFooter2 from '~/components/Pointeger/atoms/PtFooter2.vue';
import { addBasePath } from '~/helpers/addBasePath';
import HeaderLogo from '~/components/HeaderLogo.vue';
import { useNewsletter, useUiNotification, useContent } from '~/composables';

export default defineComponent({
  components: {
    HeaderLogo,
    PtCopyright,
    PtSocial,
    PtNewsLetterDesc,
    PtFooter1,
    PtFooter2,
    SfIcon,
    SfButton,
    PtInput,
  },
  props: {
    logo: {
      type: [String, Object],
      default: '',
    },
    logoHeight: {
      type: [Number, String],
      default: 35,
    },
    logoWidth: {
      type: [Number, String],
      default: 35,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    const email = ref('');
    const message = ref('');
    const { updateSubscription, loading } = useNewsletter();
    const isNotificationVisible = ref(false);
    const isError = ref(false);
    const { send: sendNotification } = useUiNotification();
    const userBlock = ref(null);
    const { loadBlocks } = useContent();
    const socialMediaIcons = ref(null);
    const footerLink1 = ref(null);
    const footerLink2 = ref(null);
    const newLetterDescription = ref(null);
    const footerCopyright = ref(null);

    useFetch(async () => {
      const blocks = await loadBlocks({
        identifiers: [
          'footer_links_2',
          'footer_links_1',
          'footer_social_links',
          'footer_Newsletter_desc',
          'footer_copyright',
        ],
      });

      userBlock.value = blocks || [];
      socialMediaIcons.value = userBlock.value.find((b:any) => b.identifier === 'footer_social_links') || null;
      footerLink1.value = userBlock.value.find((b:any) => b.identifier === 'footer_links_1') || null;
      footerLink2.value = userBlock.value.find((b:any) => b.identifier === 'footer_links_2') || null;
      newLetterDescription.value = userBlock.value.find((b:any) => b.identifier === 'footer_Newsletter_desc') || null;
      footerCopyright.value = userBlock.value.find((b:any) => b.identifier === 'footer_copyright') || null;
    });
    let typingTimeout = null;
    const newsLetterEmail = (event: any) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(() => {
        email.value = event;
      }, 500);
    };
    const onSearchHandler = async () => {
      const search = await updateSubscription({
        email: email.value,
      });
      if (search?.data && loading.value === false) {
        message.value = search?.data;
        if (message.value) {
          sendNotification({
            icon: 'success',
            id: Symbol('newsLetter-success-message'),
            message: message.value,
            persist: false,
            title: 'NewsLetter success message',
            type: 'success',
          });
        }
      } else if (search?.error && loading.value === false) {
        message.value = search?.error[0]?.message;
        isError.value = true;
        if (isError.value === true) {
          sendNotification({
            icon: 'danger',
            id: Symbol('newsLetter-error-message'),
            message: message.value,
            persist: false,
            title: 'NewsLetter error message',
            type: 'danger',
          });
        }
        // eslint-disable-next-line no-empty
      } else {}
    };
    return {
      footerCopyright,
      addBasePath,
      newsLetterEmail,
      onSearchHandler,
      message,
      isNotificationVisible,
      isError,
      userBlock,
      socialMediaIcons,
      footerLink1,
      footerLink2,
      newLetterDescription,
    };
  },
  data() {
    return {
      isMobile: false,
      desktopMin: 1024,
    };
  },
  mounted() {
    // Run the function on page load (client side)
    this.handleScreenResize();

    // Add event listener to re-check on window resizing
    window.addEventListener('resize', this.handleScreenResize);
  },
  beforeDestroy() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('resize', this.handleScreenResize);
  },
  methods: {
    // Function to add the dropdown functionality for mobile screens
    initMobileDropdown() {
      const buttons = document.querySelectorAll('.heading');
      const dropdowns = document.querySelectorAll('.links-options');
      const icons = document.querySelectorAll('.role.sf-icon');

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          const drop = dropdowns[index]; // Access the corresponding dropdown by index
          const icon = icons[index]; // Access the corresponding icon by index

          // Toggle the 'drop-open' class to control height and the sliding effect
          drop.classList.toggle('drop-open');

          // Toggle the 'rotate-arrow' class on the icon
          icon.classList.toggle('rotate-arrow');
        });
      });
    },

    // Function to remove all event listeners and reset dropdowns
    removeDropdownListeners() {
      const buttons = document.querySelectorAll('.heading');

      // Clone each button to remove existing event listeners
      buttons.forEach((button) => {
        const newButton = button.cloneNode(true); // Clone the button
        button.replaceWith(newButton); // Replace with the clone (which has no listeners)
      });
    },

    // Function to reset the dropdowns for larger screens
    resetDropdowns() {
      const dropdowns = document.querySelectorAll('.links-options');

      dropdowns.forEach((drop) => {
        drop.classList.remove('drop-open'); // Collapse the dropdowns on larger screens
      });
    },

    // Function to handle screen resize and reinitialize dropdowns accordingly
    handleScreenResize() {
      const screenWidth = window.innerWidth; // Dynamically get the current screen width

      this.removeDropdownListeners(); // Remove old event listeners before re-initializing

      if (screenWidth <= 640) {
        this.initMobileDropdown(); // Initialize dropdowns on mobile screens
      } else {
        this.resetDropdowns(); // Reset the dropdown styles on larger screens
      }
    },
  },
});
